import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from './base.service';
import { MessageService } from './message.service';

@Injectable()
export class ImportadoresService extends BaseService {

  constructor(private http: HttpClient, private message: MessageService) { super(); }

  buscarImportador() {
    return this.http.get(this.UrlService + 'Importadores/BuscarImportador')
      .pipe(map((res: any) => res.data), catchError(super.serviceError));
  }

  criarOuAtualizarImportador(dados: any) {
    return this.http.post(this.UrlService + 'Importadores/CriarOuAtualizarImportador', dados)
      .pipe(map((res: any) => res.data), catchError(super.serviceError));
  }

  verificaCertificadoCpf() {
    return this.http.get(this.UrlService + 'Importadores/VerificaCertificadoCpf')
      .pipe(map((res: any) => res.data), catchError(super.serviceError));
  }

  getCertificado() {
    return this.http.get(this.UrlService + 'Importadores/certificado')
      .pipe(map((res: any) => res.data), catchError(super.serviceError));
  }

  uploadCertificado(form: any) {
    return this.http.post(this.UrlService + 'Importadores/certificado', form)
      .pipe(map((res: any) => res), catchError(super.serviceError));
  }
}